export default "__VITE_ASSET__CAguUvOn__"